import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comunicado-covid',
  templateUrl: './comunicado-covid.component.html',
  styleUrls: ['./comunicado-covid.component.css']
})
export class ComunicadoCovidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
